import Seo from '@/components/feature/Seo';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { SITE_URL } from '@/utils/site';
import BrandIntro from './components/BrandIntro';
import Milestones from './components/Milestones';
import Reviews from './components/Reviews';
import Contact from './components/Contact';

export default function AboutPage() {
  return (
    <div>
      <Seo
        title="关于073漫画网_品牌介绍与联系我们-健身教练漫画免费阅读"
        description="了解073漫画网品牌故事、发展历程与读者口碑。073漫画网专注健身题材漫画免费阅读，如需版权合作、内容反馈或商务洽谈，欢迎通过联系方式与我们取得联系。"
        keywords="073漫画网,关于我们,品牌介绍,联系我们,健身教练漫画"
        canonicalPath="/about"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: `关于${'073漫画网'}`,
            url: `${SITE_URL}/about`,
            description: '073漫画网品牌介绍、发展历程、读者口碑与联系方式。',
            inLanguage: 'zh-CN',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '073漫画网',
            url: `${SITE_URL}/`,
            email: 'service@073manhua.com',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+86-400-073-0000',
              contactType: 'customer service',
              availableLanguage: 'Chinese',
            },
            address: {
              '@type': 'PostalAddress',
              addressRegion: '湖南省',
              addressLocality: '长沙市',
              streetAddress: '岳麓区麓谷信息港A座12层',
              addressCountry: 'CN',
            },
          },
        ]}
      />

      <div className="mx-auto max-w-7xl px-4 pb-4 pt-24 md:px-6 md:pt-28">
        <Breadcrumb items={[{ label: '关于我们' }]} />
      </div>

      <BrandIntro />
      <Milestones />
      <Reviews />
      <Contact />
    </div>
  );
}